<!-------------------------------------------- FOOTER -------------------------------------------->
<div class="login login-footer">
    <div class="col-12 col-lg-4 hide-xs-md"></div>
    <div class="col-12 col-lg-8 login-carousel-footer login-footer-flex">
        <div class="login-footer-flex-container">
            <div id="softwareVersion" class="login-footer-flex-lg-xl text-center"><span class="powered-by-rata">{{isUsingCustomDesign ? "Powered&nbsp;by " : ""}}<img
                    src="/assets/images/logos/RATA_Logo_White_Footer.png" class="powered-by-logo"></span>{{versionDetail}}</div>
            <div class="login-footer-flex-lg-xl text-center">&copy;&nbsp;{{getYear}} Techion Group Ltd</div>
            <ng-container *ngIf="showLinks">
                <div class="login-footer-flex-lg-xl text-center"><a [routerLink]="" (click)="openHelp()" class="link-text" id="help">Help</a></div>
                <div class="login-footer-flex-lg-xl text-center"><a [routerLink]="" (click)="openPrivacy()" class="link-text" id="privacy">Privacy</a></div>
                <div class="login-footer-flex-lg-xl text-center"><a [routerLink]="" (click)="openTermsAndConditions()" class="link-text" id="terms">Terms</a></div>
            </ng-container>
        </div>
    </div>
</div>